import styles from './style.module.css'
import NotFound from '@assets/search_not_found.png'
import Image from 'next/image'
import Link from 'next/link'
import { useMediaQuery } from 'react-responsive'
import { useAuth } from '@src/auth'

export default function ResultsNotFound({
  containerStyle,
  wrapperStyle,
  headerStyle,
  small,
  headerText = 'No results matching your search',
  subheaderStyle,
  subheaderText = 'Upload your resume and we’ll reach out when there’s a match',
  buttonStyle,
  buttonText = 'Upload Your Resume',
  buttonHandler,
}) {
  const smallScreen = useMediaQuery({ query: '(max-width: 560px)' })
  const { isSignedIn } = useAuth()

  const renderButton = () => {
    if (buttonHandler) {
      return (
        <div
          className={styles.buttonContainer}
          style={buttonStyle}
          onClick={buttonHandler}
        >
          {buttonText}
        </div>
      )
    }

    return (
      !isSignedIn() && (
        <Link href="/signup" passHref>
          <a>
            <div className={styles.buttonContainer} style={buttonStyle}>
              {buttonText}
            </div>
          </a>
        </Link>
      )
    )
  }

  return (
    <div className={styles.container} style={containerStyle}>
      <div className={styles.wrapper} style={wrapperStyle}>
        {smallScreen || small ? (
          <Image
            src={NotFound}
            alt="results not found"
            width="120px"
            height="120px"
            className={styles.image}
            draggable="false"
          />
        ) : (
          <Image
            src={NotFound}
            alt="results not found"
            width="190px"
            height="190px"
            className={styles.image}
            draggable="false"
          />
        )}
        <div className={styles.header} style={headerStyle}>
          {headerText}
        </div>
        <div className={styles.subHeader} style={subheaderStyle}>
          {subheaderText}
        </div>
        {renderButton()}
      </div>
    </div>
  )
}
